var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsletter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 170,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M222.405 111.366c0 29.255-25.118 53.094-56.212 53.094-17.32 0-32.816-7.369-43.147-19.071-.304-.325-.709-.758-1.013-1.192-.303.325-.709.65-1.012.975-12.762 11.919-30.385 19.288-49.629 19.288-39.095 0-70.797-29.906-70.797-66.964 0-36.949 31.702-66.963 70.797-66.963h2.33C86.078 12.546 105.929.843 128.313.843c35.044 0 63.909 28.606 67.353 65.122 16.104 9.535 26.739 26.222 26.739 45.401Z",
    fill: "#669D60",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.246 58.857C13.246 26.365 39.767 0 72.452 0c14.636 0 28.062 5.251 38.296 14.113 2.641-.22 5.282-.22 7.924-.22 49.851 0 90.239 33.805 90.239 75.705s-40.388 75.705-90.239 75.705c-45.89 0-83.747-28.663-89.47-65.859-9.793-10.72-15.956-24.943-15.956-40.587Z",
    fill: "#669D60",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.12 9.889c-.757-.8-2.032-.862-2.842-.247l-73.017 43.57c-.132.149-.132.149-.123.29l-9.497 87.64c-.378 2.992 1.478 5.56 4.038 5.824l128.902 13.982c2.56.264 4.829-1.857 5.067-4.839l9.497-87.641-.018-.282L124.12 9.89Z",
    fill: "#669068"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m70.851 19.548-10.21 93.943 101.656 11.048 10.21-93.944L70.851 19.549Z",
    fill: "#EDEDED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m128.334 38.02-.137 1.262 31.268 3.389.136-1.262-31.267-3.389ZM79.786 42.8l-.137 1.261 78.8 8.548.137-1.262-78.8-8.548ZM78.728 52.738 78.591 54l78.8 8.548.137-1.262-78.8-8.548ZM77.625 62.808l-.137 1.262 78.8 8.548.137-1.262-78.8-8.548ZM76.567 72.747l-.137 1.262 78.8 8.548.137-1.262-78.8-8.548ZM75.333 83.254l-.136 1.262 78.799 8.548.137-1.262-78.8-8.548ZM74.275 93.193l-.137 1.262 78.8 8.548.137-1.262-78.8-8.548Z",
    fill: "#FEFDF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m111.377 113.418-45.634-47.31-5.136 46.67 101.726 11.019 5.214-47.665-56.17 37.286Z",
    fill: "#DEDEDE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m154.053 93.085.202-1.284-8.683-1.012-1.768 1.1 10.249 1.196ZM75.227 84.45l9.105.984-1.363-1.469-7.54-.8-.202 1.285ZM74.357 93.124l-.203 1.284 21.062 2.357-1.364-1.469-19.495-2.172ZM152.98 103.044l.194-1.425-20.631-2.243-1.759 1.241 22.196 2.427Z",
    fill: "#E3E3DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.27 53.352c.009.14-.132.15-.132.15l-9.488 87.781c-.185 1.566.334 3.088 1.109 4.17l59.284-39.46L48.27 53.352ZM186.136 68.327l.018.282-9.497 87.641c-.185 1.566-.941 3.026-2.015 3.941l-49.426-51.454 60.92-40.41Z",
    fill: "#A6D4A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m121.142 104.611-17.076-1.899-64.316 42.6c.765.942 1.654 1.593 2.789 1.663l128.901 13.982c1.135.07 2.243-.282 3.185-1.047l-53.483-55.299Z",
    fill: "#7FC288"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m169.02 144.857 7.663 11.815-.018-.281 1.531-13.945c-.132.15-.273.159-.414.168l-8.762 2.243Z",
    fill: "#A6D4A6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M147.122 120.085c-1.03-.642-2.252.141-2.032 1.399l1.601 9.791 27.951 28.916s-.141.009-.132.15c1.082-.774 1.848-2.094 2.032-3.66l-7.663-11.815 8.762-2.244c.141-.008.273-.158.414-.167l.158-1.988c-.009-.141-.149-.132-.299-.264l-30.792-20.118Z",
    fill: "#88C093"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m174.642 160.191-27.81-28.925 4.488 26.569c.211 1.117 1.645 1.451 2.437.554l5.621-7.276 6.089 9.228 6.263.739c1.003.22 2.103-.273 2.912-.889Z",
    fill: "#60A565"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m146.823 131.126 27.819 29.065s.141-.009.132-.149l-27.951-28.916Z",
    fill: "#5B86A1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m182.392 137.238-31.083-20.241c-1.029-.643-2.252.141-2.032 1.399l6.239 36.491c.211 1.117 1.645 1.452 2.437.554l5.621-7.275 8.438 12.896c.466.678 1.179.774 1.865.449l7.46-4.989c.677-.466.774-1.179.448-1.865l-8.437-12.896 8.762-2.244c.977-.203 1.17-1.628.282-2.279Z",
    fill: "#2B4961"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.368 52.596 92.022 47.32l-3.661 35.634 51.346 5.275 3.661-35.633Z",
    fill: "#EDEDED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m106.455 67.73-10.242-1.052-1.225 11.925 10.241 1.052 1.226-11.925Z",
    fill: "#7FC288"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m121.642 56.275-10.241-1.053-2.551 24.832 10.241 1.052 2.551-24.831Z",
    fill: "#A6D4A6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m134.885 64.174-10.241-1.052-1.874 18.238 10.241 1.052 1.874-18.238Z",
    fill: "#669068"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.25bfd7a7245f6134b085d428d77170ba.svg";
export { ForwardRef as ReactComponent };